<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t('common.invoice.management') }}</div>
      <div class="outer">
        <div class="tops" style="margin-bottom: 15px">
          <div style="min-width: 240px; color: rgb(153, 153, 153)">
            <div class="sp_box">
              <div>{{ $t("invoice.des") }}</div>
              <div class="bold red">￥{{
                  Object.keys(numberInfo).length > 0 ? numberInfo.unFinishMoney.toFixed(2) : 0
                }}
              </div>
            </div>
            <div class="sp_box">
              <div>{{ $t("invoice.des2") }}</div>
              <div class="bold">￥{{ Object.keys(numberInfo).length > 0 ? numberInfo.finishMoney.toFixed(2) : 0 }}</div>
            </div>
          </div>
          <el-button type="primary" @click="requestPayStatus" size="small">
            {{ $t("invoice.request") }}
          </el-button
          >
        </div>
        <div>
          <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              @row-dblclick="handleClick"
          >
            <el-table-column prop="createTime" :label="$t('invoice.table.request.time')" width="180"/>
            <el-table-column prop="invoiceContent" :label="$t('invoice.table.request.title')" show-overflow-tooltip/>
            <el-table-column prop="invoiceMoney" :label="$t('invoice.table.request.sale')">
              <template #default="{ row, column, $index }">
                ￥{{ row.invoiceMoney ? row.invoiceMoney.toFixed(2) : '0.00' }}
              </template>
            </el-table-column>
            <el-table-column prop="invoiceStatus" :label="$t('invoice.table.request.status')">
              <template #default="{ row, column, $index }">
                <div v-if="row.invoiceStatus===1" style="color: #409eff">{{ $t("invoice.status1") }}</div>
                <div v-else-if="row.invoiceStatus===2" style="color:#67c23a ">{{ $t("invoice.status2") }}</div>
                <div v-else-if="row.invoiceStatus===3" style="color: #d93737">{{ $t("invoice.status3") }}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operate')" width="120">
              <template #default="{ row, column, $index }">
                <el-button type="primary" size="small" link @click="handleClick(row)">{{ $t("common.check") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
                size="small"
                v-model:current-page="current"
                v-model:page-size="size"
                v-if="total"
                layout="total, prev, pager, next"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BasicCard from "./Basic/BasicCard.vue";

import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {getQueryInvoiceList, getStatisticalInvoice} from "@/api/usercenter";
import {ElMessage} from "element-plus";

const router = useRouter();

const tableData = ref([]);

const current = ref(1);
const size = ref(10);
const total = ref(0);
const loading = ref(false);

const formatApplyTime = (value) => {
  if (!value) return '--'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
}

const handleCurrentChange = (page) => {
  current.value = page;
  getQueryInvoiceListApis();
};

const requestPayStatus = () => {
  router.push("/personal/applyOpen");
};


const getQueryInvoiceListApis = async () => {
  loading.value = true;
  const res = await getQueryInvoiceList(
      {
        pageNo: current.value,
        pageSize: size.value
      }
  )
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  loading.value = false;
  const {records} = res.result;
  tableData.value = records;
  current.value = res.result.current
  size.value = res.result.size;
  total.value = res.result.total;
}
const handleClick = (row) => {
  const {id, orderCode} = row
  router.push({path: '/personal/invoiceDetails', query: {id: id}})
}

// 获取开票条数
const numberInfo = ref({})
const getStatisticalInvoiceApis = async () => {
  const res = await getStatisticalInvoice()
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  numberInfo.value = res.result
}

onMounted(async () => {
  await getQueryInvoiceListApis();
  await getStatisticalInvoiceApis()
})

const rowClassName = ({columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1) {
    return {textAlign: 'left', cursor: 'pointer'}
  }
  return {textAlign: 'center', cursor: 'pointer'}
}

const headerClassName = ({columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px', 'white-space': 'nowrap'}
  }
  return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px', 'white-space': 'nowrap'}
}
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;

  .right {
    height: auto !important;
    min-height: 640px !important;
    padding-bottom: 40px !important;

  }
}

.outer {
  .tops {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
      display: flex;
      width: 240px;
      justify-content: space-between;
      align-items: center;
      height: 60px;
    }

    .sp_box {
      display: flex;
      flex-direction: column;
      align-content: center;

      & > div {
        font-size: 14px !important;
      }

      .bold {
        font-weight: bold;
        font-size: 14px;
        margin-top: 4px;
      }

      .red {
        font-size: 14px;
        color: var(--el-color-danger);
      }
    }
  }
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}

:deep(.el-table th .cell) {
  white-space: nowrap !important;
}
</style>
